import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from 'react-intl';
import * as AppPropTypes from '../../lib/PropTypes';

import Avatar from '../partials/Avatar';

import styles from '../../../styles/blocks/author.module.scss';

const propTypes = {
    image: AppPropTypes.image,
    name: PropTypes.string,
    role: PropTypes.string,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    image: null,
    name: null,
    role: null,
    className: null,
    isContainer: false,
    containerClassName: null,
};

const AuthorBlock = ({ image, name, role, className, isContainer, containerClassName }) => (
    <div
        className={classNames([
            styles.container,
            {
                [styles.isContainer]: isContainer,
                [styles.hasImage]: image !== null,
                [containerClassName]: containerClassName !== null,
                [className]: className !== null,
            },
        ])}
    >
        <p className={styles.prefix}>
            <span>
                <FormattedMessage defaultMessage="By" description="Author prefix" />
            </span>
        </p>
        {image !== null ? <Avatar className={styles.avatar} image={image} /> : null}
        <p>
            <span className={styles.name}>{name}</span>
            {role ? <span className={styles.role}>{role}</span> : null}
        </p>
    </div>
);

AuthorBlock.propTypes = propTypes;
AuthorBlock.defaultProps = defaultProps;

export default AuthorBlock;
